module.exports = __webpack_public_path__ + "img/globe.ffc50828.png";